import { render, staticRenderFns } from "./activityMySubjects.html?vue&type=template&id=543c454e&external"
import script from "./activityMySubjects.vue?vue&type=script&lang=js"
export * from "./activityMySubjects.vue?vue&type=script&lang=js"
import style0 from "./activityMySubjects.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports